import type { ReactNode } from "react";
import { useConfig } from "../state/config-context";
import { useSession } from "../state/session-context";

export function DashboardPage(): ReactNode {
  const { t } = useConfig();
  const { me, permissions } = useSession();

  if (me === null) {
    return null;
  }

  const displayName = me.user.display_name ?? me.user.email;
  const roleNames = me.roles.map((role) => role.name);

  return (
    <section className="page" aria-labelledby="dashboard-title">
      <header className="page__header">
        <h1 id="dashboard-title">{t("dashboard.title")}</h1>
        <p className="muted">{t("dashboard.welcome", { name: displayName })}</p>
      </header>

      <div className="card-grid">
        <article className="card">
          <h2 className="card__title">{t("dashboard.org")}</h2>
          <p className="card__value">{me.org.name !== "" ? me.org.name : me.org.org_type}</p>
        </article>

        <article className="card">
          <h2 className="card__title">{t("dashboard.roles")}</h2>
          {roleNames.length > 0 ? (
            <ul className="tag-list">
              {roleNames.map((name) => (
                <li key={name} className="tag">
                  {name}
                </li>
              ))}
            </ul>
          ) : (
            <p className="muted">{t("dashboard.noRoles")}</p>
          )}
        </article>

        <article className="card">
          <h2 className="card__title">{t("dashboard.mfa")}</h2>
          <p className="card__value">
            {me.mfa.enrolled ? t("dashboard.mfaEnabled") : t("dashboard.mfaDisabled")}
          </p>
        </article>

        <article className="card">
          <h2 className="card__title">{t("dashboard.session")}</h2>
          <p className="card__value">
            <code>{me.sid}</code>
          </p>
        </article>

        <article className="card card--wide">
          <h2 className="card__title">{t("dashboard.modules")}</h2>
          <p className="muted">
            {permissions.length > 0 ? permissions.join(", ") : t("dashboard.noRoles")}
          </p>
        </article>
      </div>
    </section>
  );
}
